var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"VommondCheckBoxWrapper"},[_vm._m(0),(_vm.label)?_c('span',{staticClass:"VommondCheckBoxLabel"},[_vm._v(_vm._s(_vm.label))]):_vm._e()])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"VommondCheckBox"},[_c('span',{staticClass:"VommondCheckBoxHook",attrs:{"data-dojo-attach-point":"hook"}})])
}]

export { render, staticRenderFns }